import { styled } from '@mui/material/styles';

const StyledCalendarName = styled('div')`
  display: flex;
  justify-content: space-between;
  flex-grow: 1;
`;

export default StyledCalendarName;
